/**
 * O que a tela faz com os primeiros passos que o servidor mandou.
 *
 * O servidor sabe tudo que está no banco (`src/primeiros-passos.ts`). Uma coisa
 * ele não tem como saber: se a pessoa já abriu a paleta — isso acontece no
 * navegador e não grava nada. Então este passo é da tela, e o DADO é o rastro
 * que a própria paleta deixa ao abrir (`anotarPaletaUsada`), não um "feito".
 *
 * Fora do componente porque é decisão, e decisão desta casa se prende em teste.
 */

const CHAVE_PALETA = "galera.paleta.usada";

export function paletaJaUsada() {
  try {
    return localStorage.getItem(CHAVE_PALETA) === "1";
  } catch {
    return false;
  }
}

/** A paleta chama isto ao abrir: é o dado que cumpre o passo. */
export function anotarPaletaUsada() {
  try {
    localStorage.setItem(CHAVE_PALETA, "1");
  } catch {
    /* aba restrita: o passo fica pedindo, que é o lado seguro */
  }
}

/**
 * A lista final e o resumo dela.
 *
 * @param {{ tipo?: string, passos?: object[] } | null} resposta
 * @param {{ paletaUsada?: boolean, celular?: boolean, atalho?: string }} contexto
 */
export function montarPassos(resposta, { paletaUsada = false, celular = false, atalho = "Ctrl+K" } = {}) {
  const passos = [...(resposta?.passos ?? [])];
  /* A paleta é passo de quem ATENDE: quem configura o setor chega a ela pelos
     botões dos próprios passos, e um sexto item seria ruído no dia em que ele
     menos precisa. */
  if (resposta?.tipo === "atender")
    passos.push({
      chave: "paleta",
      rotulo: celular ? "Achar qualquer coisa pela lupa" : `Abrir a paleta com ${atalho}`,
      feito: paletaUsada,
      pronto: "Você já usou a paleta.",
      falta: celular
        ? "A lupa no alto da tela acha cliente pelo nome, abre uma área ou cria uma tarefa sem procurar o botão."
        : `${atalho} abre de qualquer tela: ache cliente pelo nome, abra uma área ou crie uma tarefa sem procurar o botão.`,
      para: null,
    });
  const feitos = passos.filter((p) => p.feito).length;
  return {
    passos,
    feitos,
    total: passos.length,
    proximo: passos.find((p) => !p.feito) ?? null,
    /* Sem passo nenhum (papel que só lê) não é "tudo pronto": é não ter o que
       mostrar, e a tela não se apresenta. */
    completos: passos.length > 0 && feitos === passos.length,
  };
}
